module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.platform !== 'iOS' && _vm.$store.state.platform !== 'Android') ? _c('header', {
    class: {
      'top-searchbar': true, 'flex-box': true
    }
  }, [(_vm.goBack) ? _c('div', {
    staticClass: "back",
    on: {
      "click": function($event) {
        _vm.$route.query.platform ? _vm.bridges.GoBack() : _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weixin_fanhuishangye"
  })]) : _vm._e(), _vm._v(" "), (_vm.goSaveBack) ? _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.goSave
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weixin_fanhuishangye"
  })]) : _vm._e(), _vm._v(" "), (_vm.goPark) ? _c('div', {
    staticClass: "park-back",
    on: {
      "click": _vm.goToPark
    }
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": require("../assets/img/logo1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("返回")])]) : _vm._e(), _vm._v(" "), _vm._t("back"), _vm._v(" "), (_vm.goBackFork) ? _c('div', {
    staticClass: "back",
    on: {
      "click": function($event) {
        _vm.$route.query.platform ? _vm.bridges.GoBack() : _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-icon-"
  })]) : _vm._e(), _vm._v(" "), (_vm.bridgeBack) ? _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.bridges.GoBack
    }
  }, [_c('i', {
    staticClass: "iconfont icon-back1"
  })]) : _vm._e(), _vm._v(" "), (_vm.headTitle) ? _c('div', {
    staticClass: "title-head ellipsis"
  }, [_vm._v("\n    " + _vm._s(_vm.headTitle) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("tit-right"), _vm._v(" "), _vm._t("icon"), _vm._v(" "), _vm._t("jifenrule")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-988b55c4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 227
// module chunks = 49